'use client';
/** @jsxImportSource @emotion/react */

import type { TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead';

import MuiTableHead from '@mui/material/TableHead';

type ExcludedMuiProps = '';

interface TableHeadProps extends Omit<MuiTableHeadProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { TableHeadProps };
export const TableHead: React.FC<TableHeadProps> = MuiTableHead;

TableHead.displayName = 'TableHead';
